export const LOGIN = "/login";
export const LOGIN_OTP_VALIDATION = "/login-otp-validation";

export const RESET_PASSWORD = "/auth/action";
export const FORGOT_PASSWORD = "/forgot-password";

export const HOME = "/home";
export const PLAYGROUND = "/home/playground";
export const QA_TESTER_TOOLS = "/home/admin-qa-tester-tools";

// admin pages
export const ADMIN_DASHBOARD = "/home/admin-dashboard";
export const ADMIN_GIVEAWAYS = "/home/admin-giveaways";
export const ADMIN_WINNERS_TESTAMENTS = "/home/winners-testaments";
export const ADMIN_DISCOUNTS = "/home/admin-discounts";
export const ADMIN_PROMOS = "/home/admin-promos";
export const ADMIN_REDEEM_CODES = "/home/admin-redeem-codes";
export const ADMIN_PROMOTIONS = "/home/admin-promotions";
export const ADMIN_CONFIG = "/home/admin-config";
export const ADMIN_USERS = "/home/users";
export const ADMIN_USER_DETAIL = "/home/view-user/:userId";
export const ADMIN_ANALYTICS = "/home/analytics";
export const KPI_ANALYTICS = "/home/kpi-analytics";
export const ADMIN_ADMIN_USERS = "/home/admin-users";
export const ADMIN_ROLES = "/home/admin-roles";
export const ADMIN_NO_ACCESS = "/home/no-access";
export const ADMIN_SETTINGS = "/home/settings";
export const ADMIN_DATA_SECURITY = "/home/data-security";
export const ADMIN_PRIMARY_METRICS = "/home/admin-primary-metrics";
export const ADMIN_SEASONS = "/home/admin-seasons";
export const ADMIN_CALENDAR = "/home/admin-calendar";
export const ADMIN_SURVEY = "/home/admin-survey";
export const ADMIN_CASH_DISBURSEMENT = "/home/admin-cash-prizes";
export const ADMIN_SHOP = "/home/admin-shop";
export const ADMIN_SHOP_PRODUCT_CREATE = "/home/admin-shop/product/new";
export const ADMIN_SHOP_PRODUCT_DETAIL = "/home/admin-shop/product/:productId";
export const ADMIN_SHOP_ORDER_DETAIL = "/home/admin-shop/order/:orderId";
export const ADMIN_SHOP_CART_UPSELL =
  "/home/admin-shop/upsell/:variantId";
export const ADMIN_USER_INVITE = "/invite/:inviteId";
export const REALTIME_ANALYTICS = "/home/realtime-analytics";

// dont know whats this for? check src/routes/DirectRouteListener
export const EXCLUDED_FROM_ROUTE_SAVING = [
  HOME,
  QA_TESTER_TOOLS,
  ADMIN_ANALYTICS,
  ADMIN_USER_INVITE,
  LOGIN,
  LOGIN_OTP_VALIDATION,
  RESET_PASSWORD,
  FORGOT_PASSWORD,
];
